import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-738c489d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-settings-details" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "warning-points" }
const _hoisted_5 = { class: "buttons" }

import ChatSettingsWarningPoint from "@/components/chat/chatSettings/ChatSettingsWarningPoint.vue";
import ProfileAvatar from "@/components/images/ProfileAvatar.vue";
import SettingsDetails from "@/components/settings/SettingsDetails/SettingsDetails.vue";
import GenericButton from "@/components/buttons/GenericButton.vue";
import { ProfileAvatarSizeEnum } from "@/types/avatar";
import {
  ChatSettingsScreenEnum,
  IChatSettingsWarningPoint,
} from "@/types/chat";
import { ButtonObject, GenericButtonVariantEnum } from "@/types/button";
import { useGetChatSettingsDetailsProperties } from "./useGetChatSettingsDetailsProperties";
import { MobileNavigationProps } from "@/types/app";

interface ChatSettingsDetailsPropsObject extends MobileNavigationProps {
  primaryButton: ButtonObject;
  imageName?: string;
  imageSrc?: string;
  type: ChatSettingsScreenEnum;
  warningPoints: IChatSettingsWarningPoint[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatSettingsDetails',
  props: {
    primaryButton: {},
    imageName: {},
    imageSrc: {},
    type: {},
    warningPoints: {},
    hideDivider: { type: Boolean },
    title: {},
    handleRedirect: { type: Function },
    handleAction: { type: Function },
    actionTitle: {},
    iconType: {},
    isActionDisabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const {
  title,
  appliedImageSrc,
  primaryButtonText,
  secondaryButtonText,
  redirectBack,
} = useGetChatSettingsDetailsProperties(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SettingsDetails, _mergeProps({ gap: 62 }, { ...props, title: _unref(title) }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.imageSrc)
            ? (_openBlock(), _createBlock(ProfileAvatar, {
                key: 0,
                src: _ctx.imageSrc,
                size: _unref(ProfileAvatarSizeEnum).Big
              }, null, 8, ["src", "size"]))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _unref(appliedImageSrc),
                class: "warning-point-image",
                alt: _unref(appliedImageSrc).toLowerCase()
              }, null, 8, _hoisted_3)),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warningPoints, (point) => {
              return (_openBlock(), _createBlock(ChatSettingsWarningPoint, _mergeProps({
                key: point.title
              }, point), null, 16))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(GenericButton, {
            variant: _unref(GenericButtonVariantEnum).Primary,
            text: _unref(primaryButtonText),
            "on-click": _ctx.primaryButton.handleClick,
            "disable-translation": ""
          }, null, 8, ["variant", "text", "on-click"]),
          _createVNode(GenericButton, {
            variant: _unref(GenericButtonVariantEnum).Secondary,
            text: _unref(secondaryButtonText),
            "on-click": _unref(redirectBack)
          }, null, 8, ["variant", "text", "on-click"])
        ])
      ])
    ]),
    _: 1
  }, 16))
}
}

})